import { Vector3 } from 'three';
import { calculatePositionY } from '@/Engine/eventHandlers/libs/calculatePositionComponents';
import { Part } from '@/Engine/Part';

export function setPositionForAccessory(box: Part) {
    calculatePositionY(box, box.position.y);
    if (box.isPlasticBoxWithParentShelf()) fixPositionForBoxOnShelf(box);
}

export function fixPositionForBoxOnShelf(box: Part) {
    if (!box.parentAccessory) return;
    //в url пишем indexPositionY, но позицию относительно полки дополнительно корретируем
    const newY = box.parentAccessory[0].position.y + box.height + box.parentAccessory[0].height;
    box.position = new Vector3(box.position.x, newY, box.position.z);
}